import { render, staticRenderFns } from "./CommonPaymentTypeSelector.vue?vue&type=template&id=0b00a67c&lang=pug&"
import script from "./CommonPaymentTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./CommonPaymentTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CommonPaymentTypeSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports